import React, { useEffect, useState, useContext, useCallback } from 'react';
import Loader from '../components/loader';
import { PanoContext } from '../../contexts/PanoContextContainer';

import DragHintOverlay from '../components/dragHintOverlay';
import './style.css';

const DRAG_HINT_DURATION_MS = 4000;

function Welcome(props) {
  const { showLoader, setShowIntrudction, setOverlayVisible } = useContext(PanoContext);

  const [show, setShow] = useState(true);
  const [showImmersive, setShowImmersive] = useState(true);
  const [showDragHint, setShowDragHint] = useState(false);






  const handleDragHintDismiss = useCallback(() => {
    setShowDragHint(false);
    setShow(false);
  }, []);

  useEffect(() => {
    if (showLoader) return;
    var hotSpots = document.getElementsByClassName("hot-spot-img");
    var infoSpot = document.getElementsByClassName("info-spot-wrap");
    const timer = setTimeout(() => {
      if (hotSpots.length > 0) {
        for (let i = 0; i < hotSpots.length; i++) hotSpots[i].style.opacity = 0;
      }
      if (infoSpot.length > 0) {
        for (let j = 0; j < infoSpot.length; j++) infoSpot[j].style.display = "block";
      }
      setShowImmersive(false);
      setShowIntrudction(false);
      setShowDragHint(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, [showLoader, setShowIntrudction]);

  // Sync overlay visibility to context so PanoView can show nav arrows when overlay is dismissed
  useEffect(() => {
    setOverlayVisible(showLoader || showImmersive || show || showDragHint);
  }, [showLoader, showImmersive, show, showDragHint, setOverlayVisible]);

  return (
    <>
      <div className={`${showImmersive && 'welcome-overlay'} align-items-center justify-content-center ${ showImmersive && 'weclome-overlay-control'}`} style={{ display: (show || showDragHint) ? 'flex' : 'none' }}>
        {(showLoader || showImmersive) && <Loader />}
      </div>
      {showDragHint && (
        <DragHintOverlay
          onDismiss={handleDragHintDismiss}
          durationMs={DRAG_HINT_DURATION_MS}
        />
      )}
    </>
  );
}

export default Welcome;

